import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'user',
      'menu',
      // cart, minus the transient modal + loading flags
      'cart.added',
      'cart.discount',
      'cart.affiliate',
      'cart.orderId',
      'cart.cartUser',
      'cart.totals',
      'cart.status',
      'cart.serverCart',
      'cart.price_label',
      'cart.regionClicked',
      'employer',
      'geolocation',
      'jobSearch'
    ]
  })(store)
}